<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="text-wrapper_1 flex-col"><span class="text_3">主要经济指标</span></div>
    </div>
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng225d4c05e4b7a3d989f84e041a2250e4a20b8e49b0b1549a2aab7767c3dbe871.png"
    />
    <img
      class="image_5"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPnge009313d88a39ac5db573737286e2de04ac7f6e7d1d48b2a14ce8d64bec3ad07.png"
    />
    <div class="box_2 flex-col">
      <img
        class="image_6"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng219f67e0bc026910b53f0323756095007b4c2c9c60849d43cca57e9b69e3362b.png"
      />
      <div class="text-wrapper_2 flex-col"><span class="text_4">常住人口</span></div>
    </div>
    <img
      class="image_7"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng5c78db69bc2968cd4d1cb8fd6a7a703db19a08b2dc00af0abb11f9bc0d7b0040.png"
    />
    <div class="box_3 flex-col">
      <div class="text-wrapper_3 flex-col"><span class="text_5">生产总值及增速</span></div>
      <img
        class="image_12"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPngb319a7160e2ab3715c4f95b2dcf0bb70db9de4df3460187dc7f651ffcbb522e9.png"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />